import * as actionTypes from '../actions/actionTypes';

const initialState = {
    selectedPattern: {
        id: null
    },
    patternList: {
        quantity: 8,
        offset: 0
    },
    reloadList: false,
    authors_filter: [],
    groups_filter: [1],
    pattern_name_filter: null,
    keywords_filter: [],
    conditions_filter: [],
    constraints_filter: [],
    consequences_filter: [],
    description_filter: null,
    design_problem_filter: null,
    example_games_filter: [],
    order_by: 'auto',
    new_pattern_open: false,
    patternDetailsOpen: false,
    search_panel_active: false,
    patterns: [],
    dragging: ''
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.ADD_PATTERN:
            return {
                ...state,
                reloadList: true
            };
        case actionTypes.EDIT_PATTERN:
            return {
                ...state,
                reloadList: true
            };
        case actionTypes.VOTE_PATTERN:
            return {
                ...state,
                reloadList: true
            };
        case actionTypes.CLOSE_PATTERN_DETAILS:
            return {
                ...state,
                // keywords_filter: [...state.keywords_filter],
                patternDetailsOpen: false,
                reloadList: true
            };
        case actionTypes.SELECT_PATTERN:
            return {
                ...state,
                patternDetailsOpen: true,
                selectedPattern: { id: action.selectedPatternId }
            };
        case actionTypes.UPDATE_KEYWORDS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                keywords_filter: action.keywords_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_CONDITIONS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                conditions_filter: action.conditions_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_CONSEQUENCES_FILTER:
            return {
                ...state,
                search_panel_active: true,
                consequences_filter: action.consequences_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_CONSTRAINTS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                constraints_filter: action.constraints_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_AUTHORS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                authors_filter: action.authors_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_GROUPS_FILTER:
            return {
                ...state,
                search_panel_active: true,
                groups_filter: action.groups_filter,
                reloadList: true
            };
        case actionTypes.UPDATE_PATTERN_NAME_FILTER:
            return {
                ...state,
                search_panel_active: true,
                pattern_name_filter: action.pattern_name_filter,
                reloadList: true,
            };
        case actionTypes.UPDATE_PAGINATION:
            return {
                ...state,
                patternList: {
                    ...state.patternList,
                    offset: action.offset
                }
            };
        case actionTypes.UPDATE_ORDER_BY:
            return {
                ...state,
                order_by: action.order_by,
                search_panel_active: true
            };
        case actionTypes.NEW_PATTERN_OPEN:
            return {
                ...state,
                new_pattern_open: true,
                selectedPattern: { id: action.selectedPatternId },
            };
        case actionTypes.NEW_PATTERN_CLOSED:
            return {
                ...state,
                new_pattern_open: false,
                selectedPattern: { id: null }
            };
        case actionTypes.LIST_RELOADED:
            return {
                ...state,
                reloadList: false
            };
        case actionTypes.SEARCH_TOGGLE:
            return {
                ...state,
                search_panel_active: !state.search_panel_active,
                //keywords_filter: [],
                selectedPattern: { id: null },
            };
        case actionTypes.AUTH_LOGOUT:
            return {
                ...state,
                search_panel_active: false,
                keywords_filter: [],
                conditions_filter: [],
                constraints_filter: [],
                consequences_filter: [],
                reloadList: true,
                patternList: {
                    quantity: 8,
                    offset: 0
                },
                groups_filter: [1],
                authors_filter: [],
            };
        case actionTypes.AUTH_SUCCESS:
            return {
                ...state,
                groups_filter: [],
                authors_filter: [+action.userId], // this happens on refresh due to auto login on refresh
            }
        case actionTypes.UPDATE_DESCRIPTION_FILTER:
            return {
                ...state,
                description_filter: action.description_filter,
                reloadList: true,
            }
        case actionTypes.UPDATE_EXAMPLE_GAMES_FILTER:
            return {
                ...state,
                search_panel_active: true,
                example_games_filter: action.example_games_filter,
                reloadList: true,
            }
        case actionTypes.UPDATE_DESIGN_PROBLEM_FILTER:
            return {
                ...state,
                search_panel_active: true,
                design_problem_filter: action.design_problem_filter,
                reloadList: true,
            }
        case actionTypes.CLEAR_PATTERN_FILTERS:
            return {
                ...state,
                authors_filter: [],
                groups_filter: [],
                pattern_name_filter: null,
                keywords_filter: [],
                conditions_filter: [],
                constraints_filter: [],
                consequences_filter: [],
                description_filter: null,
                design_problem_filter: null,
                example_games_filter: [],
                reloadList: true,
            }
        case actionTypes.SUBMIT_MERGE_SELECT_MODAL:
            return {
                ...state,
                new_pattern_open: false,
            }
        case actionTypes.UPDATE_DRAGGING:
            return {
                ...state,
                dragging: action.name,
            }
        case actionTypes.CLOSE_MERGE_MODAL: {
            return {
                ...state,
                selectedPattern: {id: action.selectedPattern},
            }
        }
        default:
            return state;
    }
};

export default reducer;